import '../assets/stylesheets/lp/app.scss'
import '../assets/stylesheets/lp/validationEngine.jquery.css'
import './modules/lp/app'
import './modules/lp/jquery.validationEngine-ja'
import './modules/lp/jquery.validationEngine'

$(() => {
  $('.lp-form').validationEngine({ showArrowOnRadioAndCheckbox: true })
})
